<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="productCode"
                placeholder="productCode"
                :fieldValue.sync="formData.product_code"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                isMultiple
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="productStatus"
                :fieldValue.sync="formData.status"
                :options="productStatusOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="productName"
                placeholder="productName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="category"
                placeholder="selectCategory"
                :fieldValue.sync="formData.category_id"
                :options="categoryOptions"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                isIntegerOnly
                label="inventory"
                placeholder="0"
                :fieldValue.sync="formData.inventory"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :disabled="gEnableWarehouse && $validate.DataValid(id)"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="price"
                placeholder="0"
                :fieldValue.sync="formData.price"
                prefix="HK$"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                isStrictFloat
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="cost"
                placeholder="0"
                :fieldValue.sync="formData.cost"
                prefix="HK$"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :disabled="gEnableWarehouse && $validate.DataValid(id)"
                isStrictFloat
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" v-if="gEnablePointSystem">
              <FormInput
                type="number"
                label="neededPoints"
                placeholder="0"
                :fieldValue.sync="formData.points"
                isIntegerOnly
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" v-if="isAppMode(['T11'])">
              <FormTextarea
                label="remark"
                :fieldValue.sync="formData.remark"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="$validate.DataValid(id)">
              <label class="input-label">{{ $t('sales') }}</label>
              <span class="colorBlack--text d-flex align-center" style="height: 40px;">{{ formData.sale }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>

    <Datatable
      v-if="gEnableWarehouse && $validate.DataValid(id)"
      class="mt-10"
      tableName="warehouseRecord"
      :isLoading="warehouseFilter.loading"
      :tableHeaders="warehouseTableHeaders"
      :tableData="warehouseTableData"
      :page.sync="warehouseFilter.page"
      :pageLimit.sync="warehouseFilter.limit"
      :itemTotal="warehouseFilter.total"
      @options-update="getStocks()"
    >
      <template slot="append-toolbar-left">
        <FormButton text="add" class="ml-4 my-2" @click="handleAddWarehouse()" isAdd />
      </template>
      <template slot="append-toolbar-right">{{ $t('costAverage', { cost: formData.avg_cost }) }}</template>
      <template v-slot:[`item.type`]="{ item }"> {{ $t(`warehouseType.${item.type}`) }}</template>
      <template v-slot:[`item.resource`]="{ item }"
        >{{ $t(`warehouseResource.${item.resource}`)
        }}{{ $validate.DataValid(item.staff_name) ? ` (${item.staff_name})` : '' }}</template
      >
    </Datatable>

    <!-- Modal: 入倉紀錄 -->
    <FormDialog
      v-if="gEnableWarehouse && $validate.DataValid(id)"
      title="warehouseRecord"
      ref="warehouseDialog"
      formRef="warehouseForm"
      :maxWidth="600"
    >
      <v-row class="ma-0">
        <v-col class="ma-0" cols="12" md="6">
          <FormSelect
            label="exitOrArrival"
            placeholder="exitOrArrival"
            :fieldValue.sync="warehouseData.type"
            :options="warehouseTypeOptions"
            :dispatchUpdateOnChange="dispatchUpdateOnChange"
            @changed="warehouseData.cost = ''"
            required
          />
        </v-col>
      </v-row>
      <v-row class="ma-0" v-if="$validate.DataValid(warehouseData.type)">
        <v-col class="ma-0 pr-1" cols="8">
          <FormDatePicker
            label="createdTime"
            disableClear
            :dateValue.sync="warehouseData.date"
            required
            disabledActionButtons
          />
        </v-col>
        <v-col class="ma-0 pl-0" cols="4">
          <FormTimePicker
            :fieldValue.sync="warehouseData.time"
            :options="createTimeOptions"
            required
            style="margin-top: 26px"
          />
        </v-col>
        <v-col class="ma-0" cols="12" md="6">
          <FormInput type="number" isIntegerOnly label="quantity" :fieldValue.sync="warehouseData.qty" required />
        </v-col>
        <v-col class="ma-0" cols="12" md="6" v-if="warehouseData.type === 'add_stock'">
          <FormInput
            type="number"
            label="costPerItem"
            :fieldValue.sync="warehouseData.cost"
            prefix="HK$"
            required
            isStrictFloat
          />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormTextarea from '@/components/formField/FormTextarea.vue'
import Datatable from '@/components/Datatable.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormTimePicker from '@/components/formField/FormTimePicker.vue'

export default {
  name: 'ProductDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
    FormTextarea,
    Datatable,
    FormDialog,
    FormDatePicker,
    FormTimePicker,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    formData: {
      product_code: '',
      schools: [],
      status: 'active', // 'active' | 'inactive'
      name: '',
      category_id: null,
      inventory: '',
      price: '',
      cost: '',
      sale: '',
      // --- for T11
      remark: '',
      points: '',

      avg_cost: 0,
    },
    tutorSchoolOptions: [],
    categoryOptions: [],

    warehouseTableData: [],
    warehouseFilter: {
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
    },
    warehouseData: {
      type: '',
      date: '',
      time: '',
      qty: '',
      cost: '',
    },
    createTimeOptions: [],

    productStatusOptions: [
      { value: 'active', text: vm.$t('active') },
      { value: 'inactive', text: vm.$t('inactive') },
    ],
    warehouseTableHeaders: [
      { value: 'create_date', text: vm.$t('createdTime'), width: 130 },
      { value: 'type', text: vm.$t('exitOrArrival'), width: 130 },
      { value: 'resource', text: vm.$t('resource') },
      { value: 'amount', text: vm.$t('quantity') },
      { value: 'cost', text: vm.$t('costPerItem'), align: 'end' },
    ],
    warehouseTypeOptions: [
      { value: 'add_stock', text: vm.$t('warehouseType.add_stock') },
      { value: 'export_stock', text: vm.$t('warehouseType.export_stock') },
    ],
  }),
  methods: {
    async _getProductById(init = true) {
      try {
        const data = await this.$Fetcher.GetProductById(this.id, { with_stock: '' })
        if (init) {
          // staff只可以view所屬分校product
          if (this.$validate.DataValid(data.schools, true)) {
            let pass = false
            const getUserSchools = this.gfGetUserSchools()
            for (let i = 0; i < data.schools.length; i++) {
              if (getUserSchools.includes(data.schools[i])) {
                pass = true
                break
              }
            }
            if (!pass) {
              this.permissionValid = false
              throw 'message.notBelongProductBranch'
            }
          }
        }

        this.formData.schools = []
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        let isAllSchool = true
        for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
          if (this.tutorSchoolOptions[i].value !== -1) {
            const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
            if (!found) {
              isAllSchool = false
              break
            }
          }
        }
        if (isAllSchool) this.formData.schools.push(-1)

        if (init) {
          // TODO (BUG): 而家backend會攞曬所有order，冇filter走啲退咗/void咗嘅單
          const sale = await this.$Fetcher.GetProductSale(this.id)
          this.formData.sale = sale
        }

        if (this.gEnableWarehouse) this.getStocks()
      } catch (err) {
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'ProductList',
          })
        }
      }
    },
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.tutorSchoolOptions = filtered.map(el => {
            return { value: el.id, text: el.name }
          })

          let disabledAll = false
          const getUserSchools = this.gfGetUserSchools()
          if (this.$validate.DataValid(this.id)) {
            // when edit，不屬於staff的分校會disabled
            this.tutorSchoolOptions = this.tutorSchoolOptions.map(el => {
              const disabled = !getUserSchools.includes(el.value)
              if (disabled) {
                disabledAll = true
              }
              return {
                ...el,
                disabled: disabled,
              }
            })
          } else {
            // When create，只會攞staff所屬嘅分校
            this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))
          }

          this.tutorSchoolOptions.unshift({
            value: -1,
            text: this.$t('allCenters'),
            disabled: disabledAll,
          })
        }
      } catch {}
    },
    async _getProductCategoryOptions() {
      try {
        const { data } = await this.$Fetcher.GetProductCategories()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.categoryOptions = filtered.map(el => {
            return {
              value: el.id,
              text: el.name,
            }
          })
        }
      } catch {}
    },

    // -- (確認)
    async save() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        // ------------- payload -------------
        let payload = {
          schools: this.formData.schools.filter(el => el !== -1),
          status: this.formData.status,
          product_code: this.formData.product_code,
          name: this.formData.name,
          category_id: this.$validate.DataValid(this.formData.category_id) ? this.formData.category_id : -1,
          price: this.$validate.DataValid(this.formData.price) ? parseFloat(this.formData.price) : 0,
        }
        if (this.gEnablePointSystem) {
          payload['points'] = this.$validate.DataValid(this.formData.points) ? parseInt(this.formData.points) : 0
        }
        if (this.isAppMode(['T11'])) {
          payload['remark'] = this.formData.remark
        }
        if (!this.$validate.DataValid(this.id) || !this.gEnableWarehouse) {
          payload['inventory'] = this.$validate.DataValid(this.formData.inventory)
            ? parseInt(this.formData.inventory)
            : 0
          payload['cost'] = this.$validate.DataValid(this.formData.cost) ? parseFloat(this.formData.cost) : 0
        }
        // ---------- End of payload ----------

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdateProduct(this.id, payload)
          message = {
            message: 'message.saveSuccess',
            refresh: true,
          }
        } else {
          await this.$Fetcher.NewProduct(payload)
          message = {
            message: 'message.createSuccess',
            redirect: 'ProductList',
          }
        }

        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          type: 'success',
        })
      } catch (err) {
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteProduct(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'ProductList',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ========= 入倉紀錄 =========
    async getStocks() {
      this.warehouseFilter.loading = true
      try {
        let payload = {
          filter_limit: this.warehouseFilter.limit,
          filter_page: this.warehouseFilter.page - 1,
          filter_item: [{ key: 'product_id', value: this.id }],
          join_staff_data: true,
        }

        const { data, total } = await this.$Fetcher.GetProductStocks(payload)
        this.warehouseTableData = data.map(item => {
          const createDate = item.date ? item.date : item.create_date
          let type = item.type
          switch (item.type) {
            case 'add_stock':
            case 'return_stock':
              type = 'add_stock'
              break
            case 'export_stock':
            case 'sale_stock':
              type = 'export_stock'
              break
          }

          return {
            ...item,
            create_date: `${createDate.substring(0, 10)} ${createDate.substring(11, 16)}`,
            type: type,
            resource: item.type,
          }
        })
        this.warehouseFilter.total = total
      } catch (err) {
        this.$common.error(err)
        this.warehouseTableData = []
        if (this.warehouseFilter.page === 1) {
          this.warehouseFilter.total = 0
        }
      }
      this.warehouseFilter.loading = false
    },
    async handleAddWarehouse(newOpen = true) {
      if (newOpen) {
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        const today = this.$formatter.convertDate()
        this.warehouseData.date = this.$formatter.formatDate()
        this.warehouseData.time = `${this.$formatter.pad(today.getHours())}:${this.$formatter.pad(today.getMinutes())}`
        this.warehouseData.qty = ''
        this.warehouseData.cost = ''
        this.warehouseData.type = ''
      } else {
        this.$refs.warehouseDialog.setLoading(false)
      }

      const confirm = await this.$refs.warehouseDialog.show()
      if (confirm) {
        try {
          let payload = {
            product_id: this.id,
            cost: 0,
            amount: parseInt(this.warehouseData.qty),
            date: `${this.warehouseData.date}T${this.warehouseData.time}:00Z`,
          }

          if (this.warehouseData.type === 'add_stock') {
            payload['cost'] = parseFloat(this.warehouseData.cost)

            await this.$Fetcher.AddProductStock(payload)
          } else if (this.warehouseData.type === 'export_stock') {
            await this.$Fetcher.ReduceProductStock(payload)
          }
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })

          this.$refs.warehouseDialog.hide()
          this.warehouseFilter.loading = true
          this._getProductById()
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.handleAddWarehouse(false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: ProductDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      await this._getTutorSchoolOptions()
      await this._getProductCategoryOptions()
      if (this.$validate.DataValid(this.id)) {
        await this._getProductById()
      }

      this.$store.dispatch('toggleLoadingPage', false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    if (this.gEnableWarehouse) {
      this.warehouseFilter.loading = true
    }

    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  created() {
    this.createTimeOptions = []
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j++) {
        this.createTimeOptions.push(`${this.$formatter.pad(i)}:${this.$formatter.pad(j)}`)
      }
    }
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
